import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

import { ref, onMounted, computed } from 'vue';
import { BaseTabs, BaseTabPane } from 'xrk-components';
import { DBGYS_TABS } from '@V/invoice/src/constants';
import { RouteQuery } from '@V/invoice/src/types';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-dbgys-main',
  setup(__props) {

const route = useRoute();
const routeQuery = route.query as RouteQuery;

const subTab = ref(1);
const subTabs = computed(() => Object.values(DBGYS_TABS));
const curCmopt = computed(() => DBGYS_TABS[subTab.value]?.cmpt);
const curCmoptProps = computed(() => {
  const child = DBGYS_TABS[subTab.value];
  // type 既作开票记录的 invoiceTabType，也作待开票（复用 gt 列表）的 scene 标记
  return { invoiceTabType: (child as any)?.type, scene: (child as any)?.type };
});

onMounted(async () => {
  subTab.value = +(routeQuery.subTab || 1);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (subTabs.value.length > 1)
      ? (_openBlock(), _createBlock(_unref(BaseTabs), {
          key: 0,
          style: {"margin":"10px 0"},
          modelValue: subTab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((subTab).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subTabs.value, (item) => {
              return (_openBlock(), _createBlock(_unref(BaseTabPane), {
                label: item.label,
                name: item.value,
                key: item.value
              }, null, 8, ["label", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_resolveDynamicComponent(curCmopt.value), _normalizeProps(_guardReactiveProps(curCmoptProps.value)), null, 16))
  ]))
}
}

})